// extracted by mini-css-extract-plugin
export default {"wrapper":"Team_wrapper__QK+rV","titleWrapper":"Team_titleWrapper__d2XUA"};